<template>
  <div>
    <v-toolbar dark color="cyan">
      <v-layout justify-space-between>
        <v-toolbar-title>{{new Date() | moment("dddd, MMMM Do")}}</v-toolbar-title>
        <h1 v-show="curTempDisplay">
          <i class="mr-2 wi" :class="[classWI]"></i> {{ curTempDisplay }}°
        </h1>
        <v-spacer></v-spacer>
      </v-layout>
    </v-toolbar>
    <!-- <v-toolbar class="orange">
      <v-toolbar-title class="white--text">Your Home Screen is Coming Soon!</v-toolbar-title>
    </v-toolbar> -->
    <!-- End: Lead Management -->
    <v-layout row wrap>
      <v-flex xs12 md8>
        <v-layout column>
          <v-layout row wrap>
          <!-- Profile Tile -->
            <v-flex xs12 md7 class="pa-3">
              <v-toolbar flat dark height="50px" color="secondary">
                <v-toolbar-title>{{timeOfDay + ' ' + user.first_name }}!</v-toolbar-title>
              </v-toolbar>
              <v-layout row wrap class="card">
                <v-flex xs4>
                  <v-avatar :size="100" style="cursor: pointer">
                    <avatar :size="100" :username="userFullName" :src="user.avatar ? user.avatar : undefined"></avatar>
                  </v-avatar>
                </v-flex>
                <v-flex xs8 class="mt-3">
                  <span class="title">{{user.first_name + ' ' + user.last_name}}</span><br>
                  <span class="subheading">{{user.role}}</span>
                </v-flex>
                <!-- <v-layout class="mt-4" row wrap>
                  <v-btn class="primary">Edit Profile</v-btn>
                  <v-btn class="primary"><v-icon left>notification_important</v-icon>{{notifications && notifications.length > 0 ? notifications.length : 0}} Notifications</v-btn>
                </v-layout> -->
              </v-layout>
            </v-flex>
            <!-- End: Profile Tile -->
          <!-- Weather Tile -->
            <v-flex xs12 md5 class="pa-3">
              <v-toolbar flat dark height="50px" color="secondary">
                <i class="mr-2 wi" :class="[classWI]"></i>
                <v-toolbar-title>Current Weather</v-toolbar-title>
              </v-toolbar>
              <!-- <div class="row"> -->
                <div class="medium-6 medium-offset-3 columns card" id="weatherApp">
                  <h4  v-show="city">{{ city }}</h4>
                  <span class="text-caption" v-show="curTempDisplay">{{ weatherMain }}: {{ weatherDesc }}</span>
                  <h1 v-show="curTempDisplay">
                    <i class="wi" :class="[classWI]"></i> {{ curTempDisplay }}°
                  </h1>
                </div>
              <!-- </div> -->
            </v-flex>
            <!-- End: Weather Tile -->
          </v-layout>
          <!-- Assigned Projects -->
          <v-flex xs12 class="pa-3">
            <v-toolbar flat class="secondary white--text" height="50px">
              <v-icon dark left>ballot</v-icon>
              <v-toolbar-title>Your Assigned Projects</v-toolbar-title>
            </v-toolbar>
          <!-- Table Contents -->
            <v-data-table :headers="headers" :loading="loading" :items="projects" :search="search" :item-key="projects.id" hide-actions>
              <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">{{ props.header.text }}</span>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <tr style="cursor: pointer">
                <td class="tableRow hidden-xs-only" @click="selectProject(props.item.id)">
                  <v-layout row>
                    <v-icon left>today</v-icon>
                    <v-layout row wrap>
                      <v-flex ml-3>{{ props.item.start_date.seconds | moment("from") }}</v-flex>
                      <v-flex xs12 caption ml-3>{{ props.item.start_date.seconds | moment("dddd, MMMM Do YYYY") }}</v-flex>
                    </v-layout>
                  </v-layout>
                </td>
                <td class="tableRow" @click="selectProject(props.item.id)">
                  <v-layout row>
                    <v-layout row wrap>
                      <v-flex ml-3>{{ props.item.job_number ? '#' + props.item.job_number : '' }}</v-flex>
                    </v-layout>
                  </v-layout>
                </td>
                <td class="tableRow" @click="selectProject(props.item.id)">
                  <v-layout row>
                    <v-icon>ballot</v-icon>
                    <v-layout row wrap>
                      <v-flex ml-3>{{ props.item.name }}</v-flex>
                      <v-flex xs12 caption ml-3>{{ props.item.address }} {{ props.item.city }}, {{ props.item.state }} {{ props.item.zip }}</v-flex>
                    </v-layout>
                  </v-layout>
                </td>
                <!-- Progress Bar -->
                <td @click="selectProject(props.item.id)" class="hidden-xs-only">
                  <v-layout row>
                    <v-layout row wrap>
                      <v-flex v-if="props.item.pastDueTasks && props.item.status !== 'Completed'" xs12 class="body-1">
                        <v-icon size="20px" class="ml-2" color="red">error</v-icon><span class="red--text ml-1">{{props.item.pastDueTasks}} Past Due Tasks</span>
                      </v-flex>
                      <v-flex xs12 caption>
                        <div v-if="props.item.status !== 'Completed'" class="w3-light-grey w3-round-xlarge" style="width:100%">
                          <div class="w3-container w3-round-xlarge" :class="props.item.progress === 0 ? 'w3-clear' : 'w3-blue'" :style="getProgress(props.item.progress)">{{props.item.progress + '%'}}</div>
                        </div>
                        <div v-if="props.item.status === 'Completed'">
                          <span class="subheading">Completed</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </td>
                </tr>
              </template>
            </v-data-table>
          <!-- End: Table Contents -->
          </v-flex>
          <!-- End Assigned Projects -->
        </v-layout>
      </v-flex>
      <!-- Personal Notes -->
      <v-flex xs12 md4 class="pa-3">
        <v-card style="min-height: 550px">
        <v-toolbar flat color="secondary" dark height="50px">
          <v-icon dark left>library_books</v-icon>
          <v-toolbar-title>Personal Notes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="showNoteForm = true" icon>
            <v-icon>add</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout v-if="showNoteForm" row wrap>
          <v-flex xs12 pt-3 pl-3 pr-3>
            <v-textarea outline v-model="newNote" label="Add A New Note"></v-textarea>
          </v-flex>
          <v-flex xs12 pl-3>
            <v-checkbox class="mt-0 pt-0 pb-0" label="Flag Note" v-model="flagNote" />
          </v-flex>
          <v-layout ml-3 mb-3 row>
            <v-btn @click="addNote" class="primary">SAVE NOTE</v-btn>
            <v-btn @click="showNoteForm = false" class="secondary">CANCEL</v-btn>
          </v-layout>
        </v-layout>
        <v-divider v-if="showNoteForm" class="mb-3"></v-divider>
        <div class="pb-4">
          <template v-for="(note, index) in personalNotes">
            <div class="mt-4" :key="index">
              <v-layout row>
              <div class="ml-2" style="float: left">
                <v-avatar><v-tooltip top>
                  <avatar slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}</v-tooltip>
                </v-avatar>
              </div>
              <div class="ml-3">
                <div class="primary--text font-weight-bold">
                  {{ note.timestamp.seconds | moment("from") }}
                  <v-tooltip bottom v-if="note.flagged">
                    <v-icon slot="activator" color="red" dark>flag</v-icon>
                    <span>{{note.flagged}}</span>
                  </v-tooltip>
                  <v-btn icon style="margin-right: -20px"><v-icon small @click="editNote = note; showNoteEditDialog = true">edit</v-icon></v-btn>
                  <v-btn icon><v-icon small @click="deletePersonalNote(note)">cancel</v-icon></v-btn>
                </div>
                <div class="black--text">{{ note.note }}</div>
              </div>
              </v-layout>
              <!-- <v-list-tile-action>
                <v-btn v-if="canEdit" icon><v-icon @click="deleteNote(note)">clear</v-icon></v-btn>
              </v-list-tile-action> -->
            </div>
          </template>
          <v-flex class="mt-3">
            <span v-if="personalNotes.length < 1" class="ml-3 title">You have no personal notes.</span>
          </v-flex>
        </div>
        </v-card>
      </v-flex>
      <!-- End: Personal Notes -->
    </v-layout>
    <!-- Start: Edit Note Dialog -->
    <v-dialog v-model="showNoteEditDialog" width="500" persistent>
      <v-toolbar dark flat class="secondary headline mb-0">
        <v-toolbar-title>Edit Personal Note</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="ml-4" dark flat icon @click="showNoteEditDialog = false"><v-icon>cancel</v-icon></v-btn>
      </v-toolbar>
      <v-container class="white">
        <v-layout row wrap>
          <v-flex xs12 pt-3 pl-3 pr-3>
            <v-textarea outline v-model="editNote.note"></v-textarea>
          </v-flex>
          <v-flex xs12 pl-3>
            <v-checkbox class="mt-0 pt-0 pb-0" label="Flag Note" v-model="editNote.flagged" />
          </v-flex>
          <v-layout ml-3 mb-3 row>
            <v-btn @click="editPersonalNote" class="primary">SAVE NOTE</v-btn>
            <v-btn @click="showNoteEditDialog = false" class="secondary">CANCEL</v-btn>
          </v-layout>
        </v-layout>
      </v-container>
    </v-dialog>
    <!-- End: Edit Note Dialog -->
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import axios from 'axios'
import _ from 'lodash'
// import {auth} from '../firebaseInit'

export default {
  props: ['notifications'],
  data () {
    return {
      editNote: {note: null, flagged: null},
      showNoteEditDialog: false,
      newNote: null,
      showNoteForm: false,
      flagNote: false,
      latitude: 0.0,
      longitude: 0.0,
      city: '',
      curTemp: null,
      dataObj: null,
      weatherMain: 'Fine',
      weatherDesc: 'Clear day',
      errorMsg: '',
      search: null,
      headers: [
        { text: 'Start Date', class: ['hidden-xs-only'], value: 'start_date' },
        { text: 'Job Number', align: 'right', value: 'job_number' },
        { text: 'Project', align: 'left', value: 'name' },
        { text: 'Progress', class: ['hidden-xs-only'], value: 'progress' },
        // Hidden Headers Used For Search
        { text: 'city', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'city' }
      ]
    }
  },
  mounted () {
    this.getLocation()
    this.$store.dispatch('getProjectList', {status: 'All', tasks: false, assignedOnly: true})
    this.$store.dispatch('getUsers') // Users were not loading initially for some reason
    if (!this.$store.getters.user.filters) {
      this.$store.dispatch('saveUserFilters', this.$store.getters.defaultFilters) // Loads default filters if user has none
    }
  },
  // created () {
  //   var user = auth.currentUser;
  //   var newEmail = 'tyler@tylerdelange.com'
  //   this.$store.dispatch('editUser', { newState: { email: newEmail } })
  // },
  computed: {
    projects () {
      let getProjects = this.$store.getters.projectList
      getProjects = getProjects.filter(f => f.status !== 'Completed')
      let projects = []
      // Filter Completed vs Active
      getProjects.forEach(project => {
        let totalTasks = 0
        let completedTasks = 0
        let pastDueTasks = 0
        if (project.tasks && !project.revertedToLeads) {
          const taskIds = Object.keys(project.tasks)
          totalTasks = taskIds.length
          taskIds.forEach(task => {
            if (project.tasks[task].status === 'Completed' || project.tasks[task].status === 'Not Applicable') {
              completedTasks++
            }
            if (project.tasks[task].due_date && project.tasks[task].status !== 'Completed' && project.tasks[task].status !== 'Not Applicable' && project.tasks[task].due_date.seconds < new Date().getTime() / 1000) {
              pastDueTasks++
            }
          })
          const progress = totalTasks === 0 || completedTasks === 0 ? 0 : Math.round(completedTasks / totalTasks * 100)
          projects.push({...project, totalTasks, completedTasks, pastDueTasks, progress})
        } else if (!project.revertedToLeads) {
          projects.push({...project, totalTasks: 0, completedTasks: 0, progress: 0, pastDueTasks: 0})
        }
      })
      return projects
    },
    personalNotes () {
      return _.orderBy(this.$store.getters.personalNotes, 'timestamp.seconds', 'desc')
    },
    userFullName () {
      return this.user.first_name + ' ' + this.user.last_name
    },
    // Start: Weather Functions
    classWI: function () {
      if (this.dataObj != null) {
        var weatherID = this.dataObj.weather[0].id
        if (weatherID >= 200 && weatherID <= 232) {
          return 'wi-thunderstorm'
        } else if (weatherID >= 300 && weatherID <= 321) {
          return 'wi-sprinkle'
        } else if (weatherID >= 500 && weatherID <= 531) {
          return 'wi-rain'
        } else if (weatherID >= 600 && weatherID <= 622) {
          return 'wi-snow'
        } else if (weatherID >= 701 && weatherID <= 781) {
          return 'wi-train'
        } else if (weatherID === 800) {
          return 'wi-moon-alt-new'
        } else if (weatherID >= 801 && weatherID <= 804) {
          return 'wi-cloud'
        } else if (weatherID >= 900 && weatherID <= 962) {
          return 'wi-small-craft-advisory'
        }
      }
      return ''
    },
    curTempDisplay: function () {
      if (this.curTemp != null) {
        return (this.curTemp * 9 / 5 - 459.67).toFixed(0)
      } else {
        return null
      }
    },
    // End: Weather Functions
    timeOfDay () {
      var time = new Date().getHours()
      if (time < 12) {
        return 'Good Morning'
      } else if (time < 17) {
        return 'Good Afternoon'
      } else {
        return 'Good Evening'
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    flagEditNote (flag) {
      this.editNote = {...this.editNote, flagged: flag}
    },
    editPersonalNote () {
      this.$store.dispatch('editPersonalNote', { note: {...this.editNote, timestamp: new Date()}, user: this.user })
      this.showNoteEditDialog = false
    },
    selectProject (projectId) {
      this.$router.push('/project/' + projectId)
    },
    getProgress (progress) {
      return 'width: ' + progress + '%'
    },
    deletePersonalNote (note) {
      if (confirm('Are you sure you want to delete the note: ' + note.note + '?')) {
        this.$store.dispatch('deletePersonalNote', {note: note, user: this.user})
      }
    },
    addNote () {
      this.$store.dispatch('addPersonalNote', {user: this.user, note: this.newNote, flagged: this.flagNote})
      this.showNoteForm = false
      this.newNote = null
      this.flagged = false
    },
    // Start: Weather Functions
    getLocation: function () {
      if (!navigator.geolocation) {
        this.errorMsg = 'Geolocation is not supported by your browser'
        this.city = this.errorMsg
        console.warn(this.errorMsg)
        return
      }
      var options = {timeout: 60000}
      navigator.geolocation.getCurrentPosition(this.success, this.error, options)
    },
    success: function (position) {
      this.latitude = position.coords.latitude
      this.longitude = position.coords.longitude
      this.latitude = parseFloat(this.latitude).toFixed(2)
      this.longitude = parseFloat(this.longitude).toFixed(2)
      this.getWeather()
    },
    error: function (err) {
      this.errorMsg = 'Unable to retrieve your location'
      this.city = this.errorMsg
      console.warn(`ERROR(${err.code}): ${err.message}`)
      console.warn(this.errorMsg)
    },
    getWeather: function () {
      var reqURL = 'https://api.openweathermap.org/data/2.5/weather?lat=' + this.latitude + '&lon=' + this.longitude + '&APPID=929c79404c6e263ed726a0a4ac85a886'
      axios.get(reqURL).then(response => {
        this.dataObj = response.data
        this.curTemp = this.dataObj.main.temp
        this.city = this.dataObj.name
        this.weatherMain = this.dataObj.weather[0].main
        this.weatherDesc = this.dataObj.weather[0].description
      }, function (response) {
        console.log(response)
      })
    },
    signUserOut () {
      this.$store.dispatch('signUserOut')
    }
  },
  components: {
    Avatar
  }
}
</script>


<style scoped>
/* Start: Weather Styles */
.card {
  border-radius: 0;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.13), 0 1px 5px 0 rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  padding: 1.6rem 1rem;
}
.card .link-icon i {
  margin-top: 7px;
}
.card .bottom-button {
  margin-bottom: 0;
}
.card .text-caption {
  color: #aaa;
}

h1,
h2 {
  font-family: 'Source Sans Pro', sans-serif;
}

.header {
  color: #555;
  height: 100%;
  text-align: center;
  padding-top: 5px;
}
.header .cover-heading {
  font-size: 58px;
  color: #555;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}
.w3-light-grey,
.w3-hover-light-grey:hover,
.w3-light-gray,
.w3-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
  width: 100%;
}
.w3-round-xlarge {
  border-radius: 16px;
}
.w3-blue,
.w3-hover-blue:hover {
  color: #fff !important;
  background-color: #2196f3 !important;
}
.w3-clear,
.w3-hover-clear:hover {
  color: #000 !important;
  background-color: #fff !important;
}
.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}
.w3-round-xlarge {
  border-radius: 16px;
}
/* End: Weather Styles */
</style>



// WEBPACK FOOTER //
// src/components/Home.vue